import React from 'react';
import { useHistory } from 'react-router-dom';
import { Alert, Button } from 'react-bootstrap';
import { useEntity } from '../../contexts/EntityContext';
import AcoesPageComponent from '../../components/acoes/AcoesPageComponent';

const AcoesPage: React.FC = () => {
    const history = useHistory();
    const { currentEntity } = useEntity();

    // Check if entity is selected
    if (!currentEntity) {
        return (
            <div className="acoes-page">
                <Alert variant="warning" className="mt-4">
                    <Alert.Heading>Atenção</Alert.Heading>
                    <p>
                        Para acessar o Gerenciador de Ações, você precisa selecionar uma entidade primeiro.
                    </p>
                    <hr />
                    <div className="d-flex justify-content-end">
                        <Button
                            variant="primary"
                            onClick={() => history.push('/home')}
                        >
                            Voltar para Seleção
                        </Button>
                    </div>
                </Alert>
            </div>
        );
    }

    return (
        <>
            <div className="acoes-page">
                <AcoesPageComponent />
            </div>
        </>
    );
};

export default AcoesPage; 